import { Grid, TextContent } from "@cloudscape-design/components-themed";

interface IAddressRow {
  label: string;
  value: string;
}

/**
 * 申請事業者住所モーダル 住所情報 行
 */
export const AddressRow = (props: IAddressRow) => {
  const { label, value } = props;

  return (
    <Grid gridDefinition={[{ colspan: 2 }, { colspan: 10 }]}>
      <TextContent>
        <h4>{label}</h4>
      </TextContent>
      <TextContent>
        <p>{value}</p>
      </TextContent>
    </Grid>
  );
};
